import React from 'react';
import OpportunityDetail_Comp from '../../Components/OpportunityDetail/OpportunityDetail';
import Dashboard_Comp from '../../Components/Dashboard/Dashboard';

function OpportunityDetail() {
  return (
    <>
    <Dashboard_Comp>
    <OpportunityDetail_Comp />
    </Dashboard_Comp>
    </>
  )
}

export default OpportunityDetail;